module.exports = __webpack_public_path__ + "img/pomodoro-details1.3696b1d1.png";